import { useSelector } from 'react-redux';

import { useApiQuery } from 'theSource/utils';
import { selectIsAuthenticated } from 'theSource/features';
import { useConfigurationQuery } from 'theSource/queries';
import { PageContentQueryResponseDto, PageContentResponseDto } from './types';

export interface UsePageContentQueryOutput {
  pageContent?: PageContentResponseDto;
  isLoadingPageContent: Boolean;
  isFetching: Boolean;
}
export interface UsePageContentQueryProps {
  pageContentLookupCode: string;
  orgPlanYearId?: number;
  benefitLookupCode?: string;
  orgPlanIds?: string;
  enabled?: boolean;
}

export const usePageContentQuery = ({
  pageContentLookupCode,
  orgPlanYearId,
  benefitLookupCode,
  orgPlanIds,
  enabled = true,
}: UsePageContentQueryProps) => {
  const { configuration } = useConfigurationQuery();
  const apiHost = configuration?.apiHost;
  const preferredLanguage = localStorage.getItem('preferred_language') || 'en';

  const isAuthenticated = useSelector(selectIsAuthenticated);
  const {
    data: pageContent,
    isLoading: isLoadingPageContent,
    isFetching: isFetchingPageContent,
  } = useApiQuery<PageContentQueryResponseDto>({
    queryKey:
      [pageContentLookupCode, benefitLookupCode, preferredLanguage],
    config: {
      baseURL: `${apiHost}/v2/self_service`,
    },
    params: {
      page_content_lookup_code: pageContentLookupCode,
      org_plan_year_id: orgPlanYearId,
      benefit_lookup_code: benefitLookupCode
        ? encodeURIComponent(benefitLookupCode)
        : undefined,
      org_plan_ids: orgPlanIds,
    },
    endpoint: '/enrollments/page_content',
    enabled: Boolean(isAuthenticated) && enabled,
  });

  return { pageContent, isLoadingPageContent, isFetchingPageContent };
};
